import { Button, message, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";

const SettingsPays = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    serverFetch(`dict/pay?progCompany=${process.env.REACT_APP_PROG_COMPANY}`)
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => getData(), []);

  const columns = [
    { dataIndex: "id", title: "#", width: 60 },
    { dataIndex: "name", title: "Название" },
  ];

  return (
    <div className="settings-section-root" style={{ maxWidth: "90%" }}>
      <div className="settings-section-scroll">
        <Table
          columns={columns}
          dataSource={items}
          loading={loading}
          rowKey="id"
          pagination={false}
          size="small"
          scroll={{ x: "max-content" }}
        />
      </div>
    </div>
  );
};

export default SettingsPays;
